module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '4y8z0y2r',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
